import { ComponentReadinessScore, ReadinessFinding } from './types';

export function scoreReadiness(findings: ReadinessFinding[]): ComponentReadinessScore[] {
  const byComponent = findings.reduce<Record<string, ReadinessFinding[]>>((groups, finding) => {
    groups[finding.component] = [...(groups[finding.component] ?? []), finding];
    return groups;
  }, {});
  return Object.entries(byComponent).map(([component, componentFindings]) => {
    const probable = componentFindings.filter((finding) => finding.classification === 'probable user-facing hardcoded string').length;
    const uncertain = componentFindings.filter((finding) => finding.classification === 'uncertain').length;
    const externalized = Math.max(40, 100 - probable * 22 - uncertain * 10);
    const rtlReady = !component.toLowerCase().includes('banner') && probable < 2;
    const pseudoLocalized = probable === 0;
    const status = externalized >= 90 && rtlReady ? 'Green' : externalized >= 70 ? 'Amber' : 'Red';
    return { component, externalized, rtlReady, pseudoLocalized, status };
  });
}
